import { BasicPaginationParams, DateISOString } from 'domain/Common';

export enum InsightsReportStatus {
  Creating = 'CREATING',
  Created = 'CREATED',
  Error = 'ERROR',
}

export type InsightsReportAssociatedItem = {
  id: number;
  name: string;
  date: string;
  participantsCount: number;
};

export type InsightsReportData = {
  id: number;
  name: string;
  associatedItems: InsightsReportAssociatedItem[];
  status: InsightsReportStatus;
  createdAt: DateISOString;
  anonymityFilterEnabled: boolean;
  anonymityThreshold?: number;
  pin?: string;
};

export type GetReportSourcesParams = BasicPaginationParams & { communityId: number };

export type ReportSource = {
  name: string;
  id: number;
  guestCount: number;
};

export type CreateInsightsReportParams = {
  ids: (number | undefined)[];
  selectAll: boolean;
};

export type ValidateReportPinPayload = {
  reportId: number;
  pin: string;
};
